import { connect } from 'react-redux';
import {
    actions
} from '../../../../../../redux/modules/estado_bodega/estado_bodega';
import InventarioTransicion from './InventarioTransicion';

const mstp = state => {
    return {...state.estado_bodega, permisos: state.login.me.permisos}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(InventarioTransicion)
